import React from "react";

const imgSrc = (u) => (u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
const GRILL = /grill|skewer|charcoal|ember|spit|kebab|kabab|kofta|mishkak|agashe|roast|barbecue/i;
const DRIZZLE = /honey|syrup|sugar|sweet|date|cream|pastry|cake|cookie|biscuit|halva|dessert|miel|sciroppo|pudding/i;

export function effectFor(kind, food) {
  const text = `${food?.name?.en || ""} ${food?.desc?.en || ""}`;
  if (kind === "dessert") return "honey";
  if (GRILL.test(text)) return "embers";
  if (kind === "street" && DRIZZLE.test(text)) return "honey";
  return "steam";
}

const STEAM = [{ i: 0, dx: "-18px" }, { i: 1, dx: "12px" }, { i: 2, dx: "-8px" }, { i: 3, dx: "20px" }];
const SPARKS = Array.from({ length: 9 }, (_, i) => ({ i, dx: `${(i % 3) * 14 - 14}px` }));

function Layer({ effect }) {
  if (effect === "honey") {
    return (
      <>
        {[0, 1, 2].map((i) => <span key={i} className="lf-drip" style={{ "--i": i }} aria-hidden="true" />)}
        <span className="lf-shine" aria-hidden="true" />
      </>
    );
  }
  if (effect === "embers") {
    return (
      <>
        <span className="lf-glow" aria-hidden="true" />
        {SPARKS.map((s) => <span key={s.i} className="lf-spark" style={{ "--i": s.i, "--dx": s.dx }} aria-hidden="true" />)}
        {STEAM.slice(0, 2).map((s) => <span key={s.i} className="lf-steam lf-steam--smoke" style={{ "--i": s.i + 1, "--dx": s.dx }} aria-hidden="true" />)}
      </>
    );
  }
  return <>{STEAM.map((s) => <span key={s.i} className="lf-steam" style={{ "--i": s.i, "--dx": s.dx }} aria-hidden="true" />)}</>;
}

/** Photo of a dish with a living overlay: rising steam, dripping honey or glowing embers. */
export default function LiveFood({ food, kind, alt, className = "", children }) {
  if (!food?.image) return null;
  const effect = effectFor(kind, food);
  return (
    <div className={`live-food live-food--${effect} ${className}`} data-testid={`live-food-${kind}`} data-effect={effect}>
      <img src={imgSrc(food.image)} alt={alt} loading="lazy" className="live-food__img" />
      <Layer effect={effect} />
      {children}
    </div>
  );
}
